import {getAppSessionCookieHeader} from "../appCookie";
import api from "../../../Api";

export const checkout = async (cart, client) => {
  return await api.post('cart/checkout/' + client.guid + getAppSessionCookieHeader(), cart).then((response) => {
    return response.data;
  });
}

export const clientUpdateCartGift = async (req) => {
  return await api.post('cx/cart/gift' + getAppSessionCookieHeader(), req).then((response) => {
    return response.data;
  });
}

export const clientUpdateCart = async (req) => {
  return await api.post('cx/cart/update' + getAppSessionCookieHeader(), req).then((response) => {
    return response.data;
  });
}

export const lookupClientSecret = async () => {
  return await api.post('cx/billing/secret' + getAppSessionCookieHeader()).then((response) => {
    return response.data;
  });
}

export const applyDiscountCode = async (codeRequest) => {
  return await api.post('cx/discount/apply' + getAppSessionCookieHeader(), codeRequest).then((response) => {
    return response.data;
  });
}

export const addtoWaitlist = async (inventory) => {
  return await api.post('cart/waitlist' + getAppSessionCookieHeader(), inventory).then((response) => {
    return response.data;
  });
}

export const clientAddToCart = async (inventory, guid) => {
  if (!guid) {
    let err = {
      error: true,
      message : 'Customer not found!'
    }
    return err;
  }
  return await api.post('cart/add/' + guid + getAppSessionCookieHeader(), inventory).then((response) => {
    return response.data;
  });
}

export const squareSave = async (cart) => {
  const resp = await api.post('cx/square/save' + getAppSessionCookieHeader(), cart).then((response) => {
    return response;
  });
  return resp;
}

export const squarePay = async (cart) => {
  const resp = await api.post('cx/square/pay' + getAppSessionCookieHeader(), cart).then((response) => {
    return response;
  });
  return resp;
}

function handleError(error) {
  let err = {
    error: true,
    message: error.response.data.message
  }
  return err;
};
